import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider from 'react-slick'
import {
  RefObject,
  useRef,
  createRef,
} from 'react'

import useTitleHeight from '@/hooks/useTitleHeight'
import { useGetSectionTheme } from '@/hooks'
import { WrapperContentInterface } from '@/interfaces/wrapperContent'
import WrapperContentItemsContainer from '../../components/WrapperContentItemsContainer'
import SecondaryTitle from '../../components/SecondaryTitle'
import PrimaryTitle from '../../components/PrimaryTitle'
import { HiddenHeading } from '../../components/PrimaryTitle/PrimaryTitle.styles'
import { Wrapper } from './MultipleImageAndCopy.styles'

import { ContentItem } from '@/components'
import LocalThemeProvider from '@/components/LocalThemeProvider'
import { ContentItemUITemplateKeys } from '@/interfaces/contentItem'

const MAX_SLIDES = 4

const MultipleImageAndCopy: React.FC<WrapperContentInterface> = ({
  primaryTitle,
  secondaryTitle,
  theme,
  customTheme,
  itemList,
  withSeparator
}) => {
  const sectionTheme = useGetSectionTheme(theme, customTheme)
  // Item List Generator
  const filteredItemList = itemList?.filter((item: any) => item)
  const hasDescriptiveBanner = filteredItemList?.some((item: any) => item.uiTemplate === ContentItemUITemplateKeys.DescriptiveBanner)
  const itemListCollection = hasDescriptiveBanner ? filteredItemList?.slice(0, 1) : filteredItemList?.slice(0, MAX_SLIDES)

  // Title height
  const titleRefs = useRef<RefObject<HTMLElement>[]>(Array.from({ length: itemList.length }, () => createRef()))
  const height = useTitleHeight(titleRefs.current)

  const hasInnerShadow = hasDescriptiveBanner //update with other UITemplate if needed

  const getSliderSettings = (length: number) => ({
    dots: false,
    arrows: false,
    infinite: false,
    slidesToShow: length < MAX_SLIDES ? length : MAX_SLIDES,
    swipeToSlide: true,
    variableWidth: length < 4,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1239,
        settings: {
          variableWidth: true,
          centerMode: length > 1 && length < 4,
          slidesToShow: length < 3 ? length : 3,
          slidesToScroll: 1,
          dots: length > 3,
          arrows: false,
          swipeToSlide: true,
        }
      },
      {
        breakpoint: 904,
        settings: {
          variableWidth: true,
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: length > 1,
          arrows: false,
          swipeToSlide: true,
        }
      },
    ]
  })

  const settings = getSliderSettings(itemListCollection?.length)

  const renderItemList = itemListCollection?.map((item: any, index: number) => {
    return <ContentItem
      data={item}
      key={item.sys?.id}
      ref={titleRefs.current[index]}
      height={height}
      wrapperTheme={theme}
      wrapperCustomTheme={customTheme}
    />
  })

  return (
    <LocalThemeProvider theme={{ sectionTheme }}>
      <HiddenHeading>{primaryTitle}</HiddenHeading>
      <WrapperContentItemsContainer
        style={{ overflow: 'hidden' }}
        withSeparator={withSeparator}
      >
        {secondaryTitle && <SecondaryTitle>{secondaryTitle}</SecondaryTitle>}
        <PrimaryTitle>{primaryTitle}</PrimaryTitle>
        <Wrapper
          length={itemList?.length || MAX_SLIDES}
          hasInnerShadow={hasInnerShadow}
        >
          {itemList?.length <= 1 ? (
            renderItemList
          ) : (
            <Slider {...settings}>{renderItemList}</Slider>
          )}
        </Wrapper>
      </WrapperContentItemsContainer>
    </LocalThemeProvider>
  )
}

export default MultipleImageAndCopy
